import React from "react";
import Chart from "react-apexcharts";
import useDashboardStats from "../hooks/useDashboardStats";
import "./stickyloder.css";

const TopCustomersOrdersChart = () => {
  const { analytics, loading, error } = useDashboardStats();

  if (loading)
    return (
      <div className="top-loader">
        <div className="top-loader-bar"></div>
      </div>
    );

  if (error) return <div>Failed to load top customers orders</div>;

  // Extract data
  let categories = analytics?.top_customers_orders?.map((c) => c.name) || [];
  let series =
    analytics?.top_customers_orders?.map((c) => c.total_orders) || [];

  // Ensure minimum 3 bars
  while (categories.length < 3) {
    categories.push("N/A");
    series.push(0);
  }

  return (
    <div className="card p-3">
      <h5>Top Customers Orders</h5>
      <Chart
        options={{
          chart: { type: "bar", height: 300 },
          xaxis: { categories },
          dataLabels: { enabled: true },
        }}
        series={[{ name: "Orders", data: series }]}
        type="bar"
        height={300}
      />
    </div>
  );
};

export default TopCustomersOrdersChart;
